// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.note-box p {
  padding: 0 !important;
}
.note-box h5 {
  margin-top: 10px !important;
  margin-left: 3px !important;
}

@media screen and (max-width: 550px) {
  custom-navbar ion-title {
    font-size: 14px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/withdraw/withdrawal-mail/withdrawal-mail.component.scss"],"names":[],"mappings":"AACI;EACI,qBAAA;AAAR;AAGI;EACI,2BAAA;EACA,2BAAA;AADR;;AAIA;EACI;IACI,0BAAA;EADN;AACF","sourcesContent":[".note-box{\r\n    p{\r\n        padding: 0!important;\r\n    }\r\n\r\n    h5{\r\n        margin-top: 10px!important;\r\n        margin-left: 3px!important;\r\n    }\r\n}\r\n@media screen and (max-width: 550px) {\r\n    custom-navbar ion-title {\r\n        font-size: 14px !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
